// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2KhUD","title":"Header_title__341MP","side":"Header_side__2vGsk"};